import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import MobileHeader from '../components/MobileHeader';
import HeroSection from '../components/HeroSection';
import GlobalPresenceSection from '../components/GlobalPresenceSection';
import WhoIsItFor from '../components/WhoIsItFor';
import ProductsSection from '../components/ProductsSection';
import WhyChooseUs from '../components/WhyChooseUs';
import Testimonials from '../components/Testimonials';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';

export default function LandingPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="landing-page">
      <div className="bp-desktop-only">
        <Header scrolled={scrolled} />
      </div>
      <div className="bp-mobile-only">
        <MobileHeader />
      </div>
      <HeroSection />
      <GlobalPresenceSection />
      <WhoIsItFor />
      <ProductsSection />
      <WhyChooseUs />
      <Testimonials />
      <CTASection />
      <Footer />
    </div>
  );
}
